module.exports = __webpack_public_path__ + "static/media/1.9176e71b.JPG";